import React from 'react';
import { PopUp, Button } from 'geniebook-ui/dist';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { WARNING_MAX_DAILY_WORKSHEETS_REACHED } from '@utils/constants/errors.constants';
import AbusingWorksheet from '@assets/illustration/abusing_worksheet';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

export interface MasterySurveyProps {
  warningCode: number;
  topicNames: string;
  proceedToGenerate: (action: boolean) => void;
}

interface ButtonGroupProps {
  proceedToGenerate: (value: boolean) => void;
}

const ButtonGroup = ({ proceedToGenerate }: ButtonGroupProps) => {
  const handleClick = (value: boolean) => {
    proceedToGenerate(value);
  };

  return (
    <div className={'w-full'}>
      <Button className="mb-2" onClick={() => handleClick(true)}>
        Proceed
      </Button>
      <Button variant="secondary" onClick={() => handleClick(false)}>
        I'll practise something else
      </Button>
    </div>
  );
};

const AbusingWorksheetWarning = ({
  warningCode,
  topicNames,
  proceedToGenerate,
}: MasterySurveyProps) => {
  const viewWidth = useViewWidth();

  const getTitleCopywriting = (warningCode: number) => {
    if (warningCode === WARNING_MAX_DAILY_WORKSHEETS_REACHED)
      return 'Daily worksheet limit reached';
    else return 'Topic worksheets limit reached';
  };

  const getBodyCopywriting = (warningCode: number) => {
    if (warningCode === WARNING_MAX_DAILY_WORKSHEETS_REACHED)
      return "You've hit today's worksheet cap. You can practise more worksheets for this topic, but you will not receive any bubbles.";
    else
      return `You maxed your learning for ${topicNames} this ${new Date().toLocaleString(
        'en-EN',
        { month: 'short' },
      )}! You can practise more worksheets for this topic, but you will not receive any bubbles.`;
  };

  return (
    <div>
      <PopUp
        img={<AbusingWorksheet className="ml-auto" />}
        title={getTitleCopywriting(warningCode)}
        description={getBodyCopywriting(warningCode)}
        buttonGroup={<ButtonGroup proceedToGenerate={proceedToGenerate} />}
        onClose={() => {}}
        disableBodyScroll={true}
        width={viewWidth < breakpoint.md ? `${viewWidth - 30}px` : '400px'}
      />
    </div>
  );
};

export default AbusingWorksheetWarning;
